import React from 'react';
import { Modal, type ModalProps } from 'antd';

import { FREE_TRIAL_MODAL_Z_INDEX } from '../zIndex';

type ModalTemplateProps = React.PropsWithChildren<ModalProps>;

export const ModalTemplate = ({ children, ...props }: ModalTemplateProps) => {
  return (
    <Modal width={520} zIndex={FREE_TRIAL_MODAL_Z_INDEX} {...props}>
      {children}
    </Modal>
  );
};
